<template>
  <div class="about-con">
    <div class="logo-con">
      <img
        src="../../assets/baibu/logo140.png"
        alt="百布，让天下没有难买的布"
      >
    </div>
    <div class="main-con">
      <div class="item">
        <div class="title">官方微信</div>
        <div class="txt">ibaibu</div>
      </div>
      <div class="item">
        <div class="title">客服电话</div>
        <div class="txt">400-068-0040</div>
      </div>
      <div class="item">
        <div class="title">公司地址</div>
        <div class="txt">广州市海珠区琶洲鼎新路108号唯品会全球总部大楼安越楼20-24F</div>
      </div>
      <div
        class="item"
        @click="handleGotoQuality"
      >
        <div class="title">公司资质</div>
        <div class="txt">
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div class="footer">
      <div>copyright &copy; 2013-{{new Date().getFullYear()}}</div>
      <div>广州致景信息科技有限公司</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaibuAbout',
  data() {
    return {};
  },
  methods: {
    handleGotoQuality() {
      this.$router.push({
        name: 'companyQualifyVerify',
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .about-con{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    color: #333333;
    background: #F8F8F8;
  }
  .logo-con{
    padding: 64px 0;
    text-align: center;
    img{
      width: 70px;
      height: 70px;
    }
    .edition{
      padding: 10px 0;
    }
  }
  .main-con{
    margin: 0 15px;
    padding: 15px 15px 0;
    border-radius: 8px;
    background: #FFFFFF;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.06);
    .item{
      display: flex;
      padding: 20px 0;
      border-bottom: 1px solid #E8E8E8;
      line-height: 1.4;
      .title{
        padding-right: 20px;
        color: rgba(153, 153, 153, 1);
      }
      .txt{
        flex: 1;
        text-align: right;
      }
      &:nth-last-of-type(1){
        border: none;
      }
    }
  }
  .footer{
    position: absolute;
    padding-bottom: 15px;
    width: 100%;
    right: 0;
    bottom: 0;
    text-align: center;
    color: #999999;
    line-height: 1.8;
  }
</style>
